export const Status = { ACTIVE: 'active', CREATED: 'created', FULL: 'full' }
